import React from 'react';
import { useIntl } from 'react-intl-next';
import { toolbarMessages } from '@atlaskit/editor-common/messages';
import { ToolbarDropdownMenu, ToolbarTooltip, TextIcon } from '@atlaskit/editor-toolbar';
/**
 * Basic version of existing 'Text Styles' Menu - which doesn't dynamically change icon
 * and is also placeholder to render all other menus in the collapsed state.
 */
export var TextCollapsedMenu = function TextCollapsedMenu(_ref) {
  var children = _ref.children;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: formatMessage(toolbarMessages.textStylesTooltip)
  }, /*#__PURE__*/React.createElement(ToolbarDropdownMenu, {
    iconBefore: /*#__PURE__*/React.createElement(TextIcon, {
      label: formatMessage(toolbarMessages.textStylesTooltip),
      size: "small"
    }),
    enableMaxHeight: true
  }, children));
};